import "/public/css/goods.css";
import { computed, ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from "vue-router";
import httpRequest from '@/request/index';
import { showFailToast } from 'vant';
export default {
  setup() {
    const store = useStore();
    const router = useRouter();
    let page = ref(1),
      pageSize = ref(10);
    let loading = ref(false),
      finished = ref(false);
    let list = ref([]);
    let keywords = ref("");
    const loadData = () => {
      httpRequest({
        method: "get",
        url: "?file=goods",
        params: {
          keywords: keywords.value,
          page: page.value
        }
      }).then(res => {
        if (res.state == 1) {
          loading.value = false;
          const _list = res.list;
          list.value = [...list.value, ..._list];
          if (_list.length < pageSize.value) {
            finished.value = true;
          }
          page.value++;
        } else {
          showFailToast(res.msg);
        }
      });
    };
    const goSearch = () => {
      list.value = [];
      page.value = 1;
      loading.value = false;
      finished.value = false;
    };
    const addCart = (id, no) => {
      store.dispatch("addCart", {
        id: id,
        count: no
      });
    };
    const editCart = (value, detail) => {
      store.dispatch("editCart", {
        id: detail.name,
        count: value
      });
    };
    const delCart = (id, no) => {
      if (cartList.value[id].count < no) {
        store.dispatch("editCart", {
          id: id,
          count: 0
        });
      }
    };
    let cartList = computed(() => {
      return store.state.cartItem;
    });
    onMounted(async () => {
      keywords.value = router.currentRoute.value.query.keywords;
      await store.dispatch("cklogin").then(() => {
        if (!store.state.isLogin) {
          router.replace("/login");
        }
      });
    });
    const goBack = () => {
      router.go(-1);
    };
    return {
      loading,
      finished,
      list,
      cartList,
      loadData,
      addCart,
      editCart,
      delCart,
      keywords,
      goBack,
      goSearch
    };
  }
};